import { DependencyList, useEffect, useRef } from 'react';

// like a normal useEffect, except it doesn't run on the first render
export const useUpdateEffect = (callback: () => void, dependencies: DependencyList) => {
    const isInitialRender = useRef(true);

    useEffect(() => {
        if (isInitialRender.current) {
            // Skip the effect on initial render
            isInitialRender.current = false;
            return;
        }

        // Run the effect on subsequent renders
        callback();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
};
